module.exports = __webpack_public_path__ + "img/freeNode.57da4be8.svg";